export default "__VITE_ASSET__WvDpTV7i__"